import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .hasTitle()
    .publishable()
    .hasTimestamps()
    .make();

schema.prop('date').setType(String);
schema.prop('link').setType(String);
schema.prop('source').setType(String);

export default schema;
